module.exports = __webpack_public_path__ + "static/media/galeryCurtains2.58ffc21d.jpg";